<div class="buzon-cont">

  <div class="sugerencias">
    <h5 class="title">{{ title }}</h5>
    <div class="subtitle-cont">
      <h6 class="subtitle1">{{ subtitle1 }}</h6>
      <h6 class="subtitle2">{{ subtitle2 }}</h6>
      <div class="border-bottom"></div>
    </div>
    <app-notification
      [show]="showNotification"
      [type]="notificationType"
      [title]="notificationTitle"
      [message]="notificationMessage"
    ></app-notification>
  
    <form (ngSubmit)="onSubmit()">
      <!-- Medio Contacto -->
      <div class="input-box">
        <label for="contact-type">¿Cómo desea ser contactado?</label>
        <select
          class="input-field"
          [(ngModel)]="selectedContactType"
          name="contactType"
          id="contact-type"
          (ngModelChange)="onContactTypeChange()"
        >
          <option value="" disabled hidden>Selecciona...</option>
          @for (tipo of tiposContacto; track tipo.Code) {
          <option [value]="tipo.Code">{{ tipo.Description }}</option>
          }
        </select>
        <input
          type="text"
          id="contact-info"
          class="input-field mt-2"
          [(ngModel)]="contactInfo"
          name="contactInfo"
          [maxlength]="selectedContactType === '1' ? 0 : 10"
          [maxlength]="selectedContactType === '1'  ? 100 : 10"
          [placeholder]="
            selectedContactType === '1' ? 'ejemplo@correo.com' : '8091234567'
          "
          (keydown)="validateNumberOnly($event)"
          (ngModelChange)="onContactInfoChange()"
        />
        @if (contactInfoError) {
        <small class="error-message">{{ contactInfoError }}</small>
        }
      </div>
      <!-- Tipo Solicitud -->
      <div class="input-box">
        <label for="request-type">Tipo de solicitud</label>
        <select
          class="input-field"
          [(ngModel)]="selectedRequestType"
          name="requestType"
          id="request-type"
          (ngModelChange)="validateForm()"
        >
          <option value="" disabled hidden>Selecciona...</option>
          @for (tipo of tiposSugerencia; track tipo.Code) {
          <option [value]="tipo.Code">{{ tipo.Description }}</option>
          }
        </select>
        <textarea
          rows="4"
          id="comments"
          class="input-field mt-2"
          placeholder="Comentarios/sugerencias"
          [(ngModel)]="comments"
          name="comments"
          (ngModelChange)="validateForm()"
        ></textarea>
      </div>
  
      <button type="submit" class="button mt-3 mb-3" [disabled]="!isFormValid">
        Enviar
      </button>
      <button type="button" class="button-2" (click)="resetForm()">
        Limpiar
      </button>
    </form>
  </div>


  <!-- El valor * significa que no hay url para la encuesta de satisfacción, este valor se obtiene de las configuraciones de variables de entorno -->
  @if (UserSatisfactionSurveyUrl !== '*') {
  <div class="encuesta-container">
    <a
      class="encuesta-card"
      [href]="UserSatisfactionSurveyUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      <h5 class="title">Encuesta de satisfacción</h5>
      <div class="border-bottom"></div>
      <p class="encuesta-texto">
        Llena nuestra encuesta de satisfacción y ayúdanos a mejorar tu experiencia.
      </p>
      <span class="encuesta-btn">Ir a la encuesta</span>
    </a>
  </div>
  }
</div>


